<template>
  <div>
    <div class="text-center" v-if="!isLoading || !formLoader">
      <b-spinner variant="primary" label="Text Centered"></b-spinner>
    </div>
    <b-form @submit.prevent="submit" v-if="isLoading && formLoader">
      <b-row>
        <b-col cols="12" md="12">
          <b-form-group
            :label="$lang.azmoonLang.eventCaption"
            label-for="caption"
            :label-cols="$config.azmoon.form.labelCol"
          >
            <requiredComponent
              slot="label"
              :label="$lang.azmoonLang.eventCaption"
              :rules="$v.caption.$params"
            />
            <b-form-input
              id="caption"
              type="text"
              :autocomplete="$lang.azmoonLang.eventCaption"
              v-model="$v.caption.$model"
              :state="$v.caption.$dirty ? !$v.caption.$error : null"
            >
            </b-form-input>
            <b-form-invalid-feedback id="caption-feedback"
              >{{
                $lang.azmoonLang.error_required
                  | replace($lang.azmoonLang.caption)
              }}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="12">
          <requiredComponent
            slot="label"
            :label="$lang.azmoonLang.explanation"
            :rules="$v.description.$params"
          />
          <editor dir="rtl" v-model="description">
            <br />
          </editor>
          <b-form-invalid-feedback id="name-feedback">
            {{
              $lang.azmoonLang.error_required
                | replace($lang.azmoonLang.explanation)
            }}</b-form-invalid-feedback
          >
        </b-col>
        <b-col cols="12" md="4">
          <b-form-group
            :label="$lang.azmoonLang.event_type"
            label-for="event_type"
            :label-cols="this.$config.azmoon.form.labelCol"
          >
            <requiredComponent
              slot="label"
              :label="$lang.azmoonLang.event_type"
              :rules="$v.event_type_selected.$params"
            />
            <selectFind
              :options="event_type_options"
              v-model="$v.event_type_selected.$model"
              label="text"
              id="value"
              :isValid="
                $v.event_type_selected.$dirty
                  ? !$v.event_type_selected.$error
                  : null
              "
              :loading="event_type_Loading"
            />
            <b-form-invalid-feedback
              :style="{
                display: $v.event_type_selected.$error ? 'block' : 'none',
              }"
              id="event_type_selected_feedback"
            >
              {{
                $lang.azmoonLang.error_required
                  | replace($lang.azmoonLang.event_type)
              }}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>

        <b-col v-if="showStateDefineCombo" cols="12" md="4">
          <b-form-group
            :label="$lang.azmoonLang.state_define"
            label-for="state_define"
            :label-cols="$config.azmoon.form.labelCol"
          >
            <requiredComponent
              slot="label"
              :label="$lang.azmoonLang.state_define"
              :rules="$v.state_define_selected.$params"
            />
            <selectFind
              :options="state_define_options"
              v-model="$v.state_define_selected.$model"
              label="text"
              id="value"
              :isValid="
                $v.state_define_selected.$dirty
                  ? !$v.state_define_selected.$error
                  : null
              "
              :loading="state_define_Loading"
            />
            <b-form-invalid-feedback
              :style="{
                display: $v.state_define_selected.$error ? 'block' : 'none',
              }"
              id="state_define_selected_feedback"
            >
              {{
                $lang.azmoonLang.error_required
                  | replace($lang.azmoonLang.state_define)
              }}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="4">
          <b-form-group
            :label="$lang.azmoonLang.activity_reference"
            label-for="actions_activity"
            :label-cols="$config.azmoon.form.labelCol"
          >
            <requiredComponent
              slot="label"
              :label="$lang.azmoonLang.activity_reference"
              :rules="$v.actions_selected.$params"
              :showInfo="true"
              :titleText="$lang.azmoonLang.activity_reference"
            />
            <selectFindMultiple
              :options="actions_activity"
              v-model="$v.actions_selected.$model"
              label="caption"
              id="id"
              :loading="actions_loading"
              :removeItem="removeItemActivity"
            />
            <b-form-invalid-feedback
              :style="{
                display: $v.actions_selected.$error ? 'block' : 'none',
              }"
              id="actions_activity_feedback"
            >
              {{
                $lang.azmoonLang.error_required
                  | replace($lang.azmoonLang.activity_reference)
              }}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="4">
          <b-form-group
            :label="$lang.azmoonLang.time_checkpoint"
            label-for="time_checkpoint"
            :label-cols="$config.azmoon.form.labelCol"
          >
            <requiredComponent
              slot="label"
              :label="$lang.azmoonLang.time_checkpoint"
              :rules="$v.time_checkpoint_selected.$params"
              :showInfo="true"
              :titleText="$lang.azmoonLang.time_checkpoint_tooltip"
            />
            <selectFind
              :options="time_checkpoint_options"
              v-model="$v.time_checkpoint_selected.$model"
              label="text"
              id="value"
              :isValid="
                $v.time_checkpoint_selected.$dirty
                  ? !$v.time_checkpoint_selected.$error
                  : null
              "
              :loading="time_checkpoint_Loading"
            />
            <b-form-invalid-feedback
              :style="{
                display: $v.time_checkpoint_selected.$error ? 'block' : 'none',
              }"
              id="time_checkpoint_selected_feedback"
            >
              {{
                $lang.azmoonLang.error_required
                  | replace($lang.azmoonLang.time_checkpoint)
              }}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>

        <b-col cols="12" md="4">
          <b-form-group
            :label="$lang.azmoonLang.diff_time_checkpoint"
            label-for="diff_time_checkpoint"
            :label-cols="$config.azmoon.form.labelCol"
          >
            <requiredComponent
              slot="label"
              :label="$lang.azmoonLang.diff_time_checkpoint"
              :rules="$v.diff_time_checkpoint.$params"
              :showInfo="true"
              :titleText="$lang.azmoonLang.diff_time_checkpoint_tooltip"
            />

            <b-form-input
              id="diff_time_checkpoint"
              type="number"
              min="0"
              max="999"
              :autocomplete="$lang.azmoonLang.diff_time_checkpoint"
              v-model="$v.diff_time_checkpoint.$model"
              :state="
                $v.diff_time_checkpoint.$dirty
                  ? !$v.diff_time_checkpoint.$error
                  : null
              "
            >
            </b-form-input>
            <b-form-text id="input-live-help">
              {{ $lang.azmoonLang.minute }}
            </b-form-text>
            <div
              class="invalid-feedback"
              v-if="!$v.diff_time_checkpoint.required"
            >
              {{
                $lang.azmoonLang.error_required
                  | replace($lang.azmoonLang.diff_time_checkpoint)
              }}
            </div>
            <div
              class="invalid-feedback"
              v-if="
                $v.diff_time_checkpoint.required &&
                (!$v.diff_time_checkpoint.minLengh ||
                  !$v.diff_time_checkpoint.maxLengh)
              "
            >
              {{
                $lang.azmoonLang.error_Value
                  | replace($lang.azmoonLang.diff_time_checkpoint, "0", "999")
              }}
            </div>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="4">
          <b-form-group
            :label="$lang.azmoonLang.timeing"
            label-for="timeing"
            :label-cols="$config.azmoon.form.labelCol"
          >
            <requiredComponent
              slot="label"
              :label="$lang.azmoonLang.timeing"
              :rules="$v.timeing_selected.$params"
            />
            <selectFind
              :options="timeing_options"
              v-model="$v.timeing_selected.$model"
              label="text"
              id="value"
              :isValid="
                $v.timeing_selected.$dirty ? !$v.timeing_selected.$error : null
              "
              :loading="timeing_Loading"
            />
            <b-form-invalid-feedback
              :style="{
                display: $v.timeing_selected.$error ? 'block' : 'none',
              }"
              id="timeing_selected_feedback"
            >
              {{
                $lang.azmoonLang.error_required
                  | replace($lang.azmoonLang.timeing)
              }}
            </b-form-invalid-feedback>
          </b-form-group>
        </b-col>
        <b-col cols="12" md="4">
          <b-form-group
            :label="$lang.azmoonLang.duration_activity"
            label-for="duration_activity"
            :label-cols="$config.azmoon.form.labelCol"
          >
            <requiredComponent
              slot="label"
              :label="$lang.azmoonLang.duration_activity"
              :rules="$v.duration_activity.$params"
              :showInfo="true"
              :titleText="$lang.azmoonLang.duration_activity_tooltip"
            />

            <b-form-input
              id="duration_activity"
              type="number"
              min="0"
              max="999"
              :autocomplete="$lang.azmoonLang.duration_activity"
              v-model="$v.duration_activity.$model"
              :state="
                $v.duration_activity.$dirty
                  ? !$v.duration_activity.$error
                  : null
              "
            >
            </b-form-input>
            <b-form-text id="input-live-help">{{
              $lang.azmoonLang.minute
            }}</b-form-text>
            <div class="invalid-feedback" v-if="!$v.duration_activity.required">
              {{
                $lang.azmoonLang.error_required
                  | replace($lang.azmoonLang.duration_activity)
              }}
            </div>
            <div
              class="invalid-feedback"
              v-if="
                $v.duration_activity.required &&
                (!$v.duration_activity.minLengh ||
                  !$v.duration_activity.maxLengh)
              "
            >
              {{
                $lang.azmoonLang.error_Value
                  | replace($lang.azmoonLang.duration_activity, "0", "999")
              }}
            </div>
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          v-if="
            diff_time_checkpoint && timeing_selected && time_checkpoint_selected
          "
        >
          <b-alert show variant="primary">
            <h6 class="text-center">
              {{
                $lang.azmoonLang.tooltip_activity_time
                  .replace("{0}", diff_time_checkpoint)
                  .replace("{1}", timeing_selected.text)
                  .replace("{2}", time_checkpoint_selected.text)
              }}
              <span v-if="duration_activity">{{
                $lang.azmoonLang.tooltip_duration_activity.replace(
                  "{3}",
                  duration_activity
                )
              }}</span>
            </h6>
          </b-alert>
        </b-col>

        <b-col cols="12" md="4" class="white-space mt-2">
          <b-form-checkbox
            id="start_at_time"
            v-model="start_at_time"
            name="start_at_time"
            :disabled="start_at_period == 1"
            value="1"
            unchecked-value="0"
          >
            {{ $lang.azmoonLang.start_at_time }}
            <i
              class="fa fa-info-circle fa-lg text-info"
              v-b-tooltip.hover
              :title="$lang.azmoonLang.start_at_time_tooltip"
            ></i>
          </b-form-checkbox>
        </b-col>

        <b-col cols="12" md="4" class="white-space mt-2">
          <b-form-checkbox
            id="start_at_period"
            v-model="start_at_period"
            name="start_at_period"
            :disabled="!duration_activity || start_at_time == 1"
            value="1"
            unchecked-value="0"
          >
            {{ $lang.azmoonLang.start_at_period }}
            <i
              class="fa fa-info-circle fa-lg text-info"
              v-b-tooltip.hover
              :title="$lang.azmoonLang.start_at_period_tooltip"
            ></i>
          </b-form-checkbox>
        </b-col>

        <b-col cols="12" md="4" class="white-space mt-2">
          <b-form-checkbox
            id="has_prerequisite"
            v-model="has_prerequisite"
            name="has_prerequisite"
            value="1"
            unchecked-value="0"
          >
            {{ $lang.azmoonLang.prerequisites }}
            <i
              class="fa fa-info-circle fa-lg text-info"
              v-b-tooltip.hover
              :title="$lang.azmoonLang.prerequisites_tooltip"
            ></i>
          </b-form-checkbox>
        </b-col>
        <b-col cols="12" md="12" class="mt-2 px-0">
          <uploadFile
            v-if="exerciseId && showUpload"
            :keyServies="keyServies"
            :keyValue="exerciseId"
            :file_types="file_types"
          />
        </b-col>
        <b-col v-if="!showUpload" cols="12" md="12" class="mt-2">
          <label for="">{{ $lang.azmoonLang.send_file }}</label>
          <fileDrag
            ref="fileDrag"
            @uploadFile="attachmentTemp"
            :acceptFormats="acceptFormats"
            :acceptFormatsInput="acceptFormatsInput"
            :multiple="true"
            :crop="false"
          />
          <filelistPorgress
            :fileUpload="fileUpload"
            @removeFile="removeFileProgress"
            @getResponseCode="filesCode"
            :showButton="false"
          />
        </b-col>
        <b-col cols="12" md="12" class="float-right">
          <div slot="footer" class="form-group form-btn">
            <b-button
              type="submit"
              v-if="permissionBtn"
              size="md"
              variant="success"
            >
              <i class="fa fa-check"></i>
              {{ $lang.azmoonLang.submitButton }}
            </b-button>
            <b-button
              type="reset"
              class="ml-2"
              size="md"
              variant="danger"
              @click="cancel"
            >
              <i class="fa fa-ban"></i>
              {{ $lang.azmoonLang.cancelButton }}
            </b-button>
          </div>
        </b-col>
      </b-row>
    </b-form>
  </div>
</template>

<script>
import { renderEumOptions } from "@/shared/utils";
import { pathOr } from "ramda";
import editor from "@/components/ckeditor/editor";
import uploadFile from "@/components/base/uploadFile";
import fileDrag from "@/components/fileManager/fileDrag";
import filelistPorgress from "@/components/fileManager/filelistPorgress";
import { required, numeric } from "vuelidate/lib/validators";
import { generateApiUrl } from "@/shared/utils";

export default {
  name: "activity-form",
  validations: {
    caption: {
      required,
    },
    event_type_selected: {
      required,
    },
    diff_time_checkpoint: {
      required,
      numeric,
    },
    state_define_selected: {},
    time_checkpoint_selected: {
      required,
    },
    duration_activity: {},
    description: {},
    timeing_selected: {
      required,
    },
    actions_selected: {},
  },
  components: {
    uploadFile,
    editor,
    fileDrag,
    filelistPorgress,
  },
  props: {
    permissionBtn: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object,
      default: () => {},
    },
    showUpload: {
      type: Boolean,
      default: false,
    },
    keyServies: {
      type: String,
      default: "",
    },
    term_id: {
      type: [String, Number],
      default: null,
    },
    term_code: {
      type: [String, Number],
      default: null,
    },
    showStateDefineCombo: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      file_types: ["image", "office", "media", "other"],
      state_define_options: [],
      state_define_selected: {},
      state_define_Loading: false,
      formLoader: false,
      acceptFormatsInput: "",
      acceptFormats: [
        {
          caption: "عکس",
          value: "10MB",
        },
        {
          caption: "مجموعه آفیس",
          value: "20MB",
        },
        {
          caption: "ویدیو/صوت",
          value: "50MB",
        },
        {
          caption: "بقیه فایل‌ها",
          value: "10MB",
        },
      ],
      exerciseId: null,
      caption: null,
      event_type_selected: null,
      diff_time_checkpoint: null,
      duration_activity: null,
      time_checkpoint_selected: null,
      event_type_Loading: false,
      time_checkpoint_Loading: false,
      editor: "ClassicEditor",
      editorConfig: {
        toolbar: [
          "heading",
          "|",
          "bold",
          "italic",
          "link",
          "bulletedList",
          "numberedList",
          "blockQuote",
          "maximize",
          "undo",
          "redo",
          "numberedList",
          "bulletedList",
          "simpleBox",
          "placeholder",
          "underline",
          "fontSize",
        ],
        placeholderConfig: {
          types: ["date", "color", "first name", "surname"], // ADDED
        },
        fontSize: {
          options: [10, 12, 14, "default", 18, 20, 22],
        },
        language: {
          ui: "fa",
          // But the content will be edited in fa.
          content: "fa",
        },
      },
      has_prerequisite: 0,
      start_at_time: 0,
      start_at_period: 0,
      description: null,
      timing: null,
      timeing_Loading: false,
      timeing_selected: null,
      actions_activity: [],
      actions_selected: [],
      actions_loading: false,
      fileUpload: [],
      responseCode: [],
    };
  },
  computed: {
    event_type_options() {
      return renderEumOptions("activity_type");
    },
    time_checkpoint_options() {
      return renderEumOptions("activity_time_checkpoint");
    },
    timeing_options() {
      return [
        {
          text: this.$lang.azmoonLang.timeing_options.before,
          value: 0,
        },
        {
          text: this.$lang.azmoonLang.timeing_options.after,
          value: 1,
        },
      ];
    },
  },
  methods: {
    generateApiUrl,
    async getStateDefine() {
      this.state_define_selected = null;
      try {
        this.state_define_Loading = true;

        const url = generateApiUrl(["kanoon", "term_state_combo"], [], {
          term_code: this.term_code,
        });

        const response = await this.$httpService.get(url);
        const data = pathOr([], ["data", "data"], response);
        this.state_define_options = data.map((x) => {
          return {
            text: x.state_caption,
            value: x.code,
          };
        });
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.state_define_Loading = false;
      }
    },
    removeFileProgress(item) {
      let indexFile = this.fileUpload.indexOf(item);
      let response = this.responseCode.find((x) => x.name == item.name);
      let indexResponse = this.responseCode.indexOf(response);
      this.fileUpload.splice(indexFile, 1);
      this.responseCode.splice(indexResponse, 1);
      this.$refs.fileDrag.$refs.fileupload.value = "";
    },
    filesCode(code) {
      this.responseCode = code;
      this.$emit("responseCode", this.responseCode);
    },
    removeItemActivity(item) {},
    attachmentTemp(files) {
      this.btnHidden = true;
      this.fileUpload = [...this.fileUpload, ...files];
    },
    async getAction() {
      try {
        this.actions_loading = true;
        const response = await this.$httpService.get(
          this.$config.api_url +
            this.$config.azmoon.action +
            `?resource=${this.keyServies}`
        );
        let { data } = response.data;
        this.actions_activity = data;
      } catch (error) {
        this.$generateError(error);
      } finally {
        this.actions_loading = false;
      }
    },
    cancel() {
      this.$emit("cancel", false);
      this.$emit("modal-close", false);
    },
    submit() {
      this.$v.$touch();
      if (this.$v.$error) return;

      let payload = {
        caption: this.caption,
        type_id: +pathOr(null, ["value"], this.event_type_selected),
        diff_time_checkpoint:
          this.timeing_selected && this.timeing_selected.value == 0
            ? -1 * parseInt(this.diff_time_checkpoint)
            : parseInt(this.diff_time_checkpoint),
        time_checkpoint: pathOr(null, ["value"], this.time_checkpoint_selected),
        term_id: this.term_id,
        duration: this.duration_activity && parseInt(this.duration_activity),
        has_prerequisite: this.has_prerequisite
          ? parseInt(this.has_prerequisite)
          : 0,
        start_at_time: parseInt(this.start_at_time),
        start_at_period: parseInt(this.start_at_period),
        description: this.description,
        custom_action_id: [...this.actions_selected.map((x) => x.id)],
      };
      if (this.showStateDefineCombo) {
        const term_state_code = pathOr(
          null,
          ["value"],
          this.state_define_selected
        );
        payload = { ...payload, term_state_code };
      }
      this.$emit("submit", payload);
    },
    async fetchData() {
      await this.getStateDefine();
      if (this.item && Object.keys(this.item).length > 0) {
        this.caption = this.item.caption;
        this.description = this.item.description;
        this.has_prerequisite = this.item.has_prerequisite;
        this.start_at_time = this.item.start_at_time;
        this.start_at_period = this.item.start_at_period;
        this.diff_time_checkpoint = Math.abs(this.item.diff_time_checkpoint);
        this.duration_activity = this.item.duration;
        if (
          this.item.diff_time_checkpoint ||
          this.item.diff_time_checkpoint == 0
        ) {
          let valTiming =
            Math.sign(this.item.diff_time_checkpoint) == 1 ||
            Math.sign(this.item.diff_time_checkpoint) == 0
              ? 1
              : 0;
          this.timeing_selected = this.timeing_options.find(
            (x) => x.value == valTiming
          );
        }

        this.event_type_selected = this.event_type_options.find(
          (x) => x.value === pathOr(null, ["type", "id"], this.item)
        );

        this.time_checkpoint_selected = this.time_checkpoint_options.find(
          (x) => x.value === pathOr(null, ["time_checkpoint"], this.item)
        );

        this.state_define_selected = this.state_define_options.find(
          (x) => x.value == this.item.term_state_code
        );

        if (this.item.action) {
          this.actions_selected = this.item.action_object || this.item.action;
        }
        if (this.item.action) {
          this.actions_selected = this.item.action_object || this.item.action;
        }

        this.formLoader = true;
        return;
      } else {
        this.getAction();
      }
      this.formLoader = true;
    },
  },
  async created() {
    if (this.item && Object.keys(this.item).length > 0) {
      this.exerciseId = this.item.id.toString();
    }
    this.fetchData();
  },
};
</script>

<style lang="scss">
.white-space {
  white-space: nowrap;
}
</style>
